export const getDxAiPatientClinicMuiTextField = (palette: any) => ({
  MuiTextField: {
    styleOverrides: {
      root: {
        color: "white",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      asterisk: {
        color: palette.error.main || "red", // Use theme palette error color or fallback to red
        fontWeight: "bold", // Make the asterisk bold
        fontSize: "1.25rem", // Increase the font size
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0, // Align helperText with the start of the TextField area
      },
    },
  },
});
